import req from '@/utils/request'


// 小于5M的直传方法
export const upload = (params) => {
        return req.post(`/upload/temp/file/upload`, params, '/xl');
    }
    // 生成断点续传的元数据
export const metadata = (params) => {
        return req.get(`/upload/temp/metadata/get`, params, '/xl');
    }
    // 生成断点续传的元数据
export const uploadFileSlicing = (headers, params) => {
        return req.uploadPost(`/upload/temp/block/upload`, params, '/xl', headers);
    }
    // export const relation_file = (params) => {
    //     return req.get(`/college/manage/material/upload`, params, '/xl/imag');
    // }


// // 小于5M的直传方法
// export function upload (data) {
//   return request({
//     url: 'file/upload',
//     method: 'post',
//     data
//   })
// }

// // 生成断点续传的元数据
// export function metadata (params) {
//   return request({
//     url: 'metadata/get',
//     method: 'get',
//     params
//   })
// }

// 生成断点续传的元数据
// export function uploadFileSlicing (headers,data) {
//   console.log(headers)
//   return request({
//     url: 'block/upload',
//     method: 'post',
//     headers:headers,
//     data
//   })
// }

// export function relation_file(params) {
//     return request({
//         url: 'manage/material/upload',
//         method: 'get',
//         params
//     })
// }